import type { User } from '@openx/types/user';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export type UserOption = Pick<User, 'id' | 'name'> & { email: string };

export const useUsersList = (): UserOption[] => {
  const { data: { optionsByPath: users } = {} } = useOptionsByPathQuery({
    variables: {
      path: 'deal.created_by_user_options',
    },
  });

  return useMemo(
    () =>
      users?.map(user => ({
        id: user?.id ?? '',
        name: `${user?.extra.first_name ?? ''} ${user?.extra.last_name ?? ''} (${user?.extra.email ?? ''})`.trim(),
        email: user?.extra.email ?? '',
      })) ?? [],
    [users]
  );
};
